// RSA加密
import JSEncrypt from 'jsencrypt'
import { envPwRSA } from 'CONFIG'

let publicKey = envPwRSA //公钥

// 加密方法
export const RSAencrypt = pas => {
  // 实例化jsEncrypt对象
  let jse = new JSEncrypt()
  // 设置公钥
  jse.setPublicKey(publicKey)

  return jse.encrypt(pas)
}
